import React from 'react';
// import { useSelector } from 'react-redux';
// import Confetti from './Confetti';
// import { steps } from '../../features/step/stepSlice';
import Header from './Header';

export default function AppWrapper({ children }) {
  // const { isError } = useSelector((state) => state.error);
  // const { step } = useSelector((state) => state.step);

  return (
    <main className="app">
      {/* {step === steps.success && !isError && <Confetti />} */}
      <Header />
      {children}
    </main>
  );
}
